<template>
  <component
    class="danger-button"
    :class="class_list"
    v-bind="component_attr"
    @click="$emit('click', $event)"
    :is="tag">
    <slot></slot>
  </component>
</template>

<script>
export default {
  name: "DangerButton",
    props: {
    disabled: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'button'
    },
    button_small: {
      type: Boolean,
      default: false
    },
    button_smaller: {
      type: Boolean,
      default: false
    },
    button_large: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    class_list() {
      return {
        disabled: this.disabled,
        button_small: this.button_small,
        button_large: this.button_large,
        smaller: this.button_smaller,
      }
    },
    component_attr() {
      return {
        disabled: this.disabled
      }
    }
  }
}
</script>
